<template>
    <div class="desensitization-eye-box" :class="{'has-eye': isShowEye}">
        <div class="content-box">
            <TooltipInfo :content="content" />
        </div>
        <div v-if="isShowEye" class="eye-box" title="点击查看" @click.stop="onEyeClick">
            <i class="el-icon-view"></i>
        </div>
    </div>
</template>

<script>

import TooltipInfo from './TooltipInfo/index.vue';
export default {
    name: 'DesensitizationEye',
    components: {
        TooltipInfo
    },
    props: {
        content: {
            type: [String, Number, Boolean],
            default: ''
        },
        showEye: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        isShowEye() {
            const content = [null, undefined].includes(this.content) ? '' : this.content;
            return this.showEye && String(content).length > 0;
        }
    },
    methods: {
        onEyeClick() {
            this.$emit('onReveal');
        }
    }
};
</script>

<style lang="less" scoped>
.desensitization-eye-box {
    display: inline-flex;
    align-items: center;
    max-width: 100%;
    &.has-eye {
        .content-box {
            max-width: calc(100% - 20px);
        }
    }
    .content-box {
        max-width: 100%;
    }
    .eye-box {
        width: 20px;
        flex-shrink: 0;
        box-sizing: border-box;
        padding-left: 4px;
        cursor: pointer;
        font-size: 15px;
        .el-icon-view {
            color: #00BCBF;
        }
    }
}
</style>
